let popoverEnabled = false;
const mediaQuery = window.matchMedia(document.documentElement.getAttribute("data-pql-pm-mq") || "(width <= 800px)");
mediaQuery.addEventListener('change', e => {
	document.body.classList.toggle("plauditQueryLoop--popoverMode", popoverEnabled = e.matches);
});
document.body.classList.toggle("plauditQueryLoop--popoverMode", popoverEnabled = mediaQuery.matches);

let filterFocusState = document.activeElement?.closest('.plauditQueryLoop__filtersInner--popover') ? 1 : 0;
const updateFocusStateRelatedThings = () => {
	document.body.classList.toggle('filterOpen', popoverEnabled && filterFocusState !== 0);
	document.documentElement.classList.toggle('noScroll', popoverEnabled && filterFocusState !== 0);
};

document.addEventListener('focusin', e => {
	if (e.target instanceof Element && e.target.closest('.plauditQueryLoop__filtersInner--popover')) {
		filterFocusState++;
		updateFocusStateRelatedThings();
	}
});
document.addEventListener('focusout', e => {
	if (e.target instanceof Element && e.target.closest('.plauditQueryLoop__filtersInner--popover')) {
		filterFocusState--;
		updateFocusStateRelatedThings();
	}
});
